import React from "react";

import { usePFDataContext } from "../context/PfContext";
import { useState } from "react";

import { stateList } from "../variables";

console.log("StateDropdown: ", stateList);


function StateDropdown(){

    const { pfData, updatePfData } = usePFDataContext();
    const [selectedState, setSelectedState] = useState(pfData.pfState);

    // alert(`StateDropdown: ${pfData.pfState}`);

    const handleStateChange = (event) => {
        const newState = event.target.value;
        setSelectedState(newState);
        updatePfData({ pfState: newState });
        updatePfData( { isLoading : true } )
    };

    return (
        <select 
            value={selectedState} 
            onChange={handleStateChange}
        >
            <option value="">Select a state</option>
            {stateList.map((state) => (
                <option key={state} value={state}>
                    {state}
                </option>
            ))}
        </select>
    );

}

export default StateDropdown;